/* =========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvents
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

export default [
  {
    url: '/vesselTracking/RealtimeMonitoring',
    name: 'RealtmieMonitoring',
    slug: 'RealtmieMonitoring',
    icon: 'AirplayIcon',
    i18n: 'RealtimeMonitoring'
  },
  {
    url: '/vesselTracking/Report',
    name: 'Reprot',
    slug: 'Report',
    icon: 'FolderIcon',
    i18n: 'VesselReport'
  },
  {
    url: '/vesselTracking/EventNotification',
    name: 'EventNotification',
    slug: 'EventNotification',
    icon: 'BellIcon',
    i18n: 'EventNotification'
  },
  
]
